{
  "$schema": "./schema.json",
  "bankID": {
    "common": {
      "startBankId": "Identify yourself",
      "pleaseWait": "Please wait...",
      "canceledTitle": "Cancelled",
      "loginCancelled": "Authentication was cancelled",
      "authenticationError": "Authentication failed. Please try again.",
      "back": "Back",
      "continue": "Continue",
      "cancel": "Cancel"
    },
    "SE": {
      "startBankId": "Identify yourself",
      "writeSecurityCode": "Scan QR code or enter security code",
      "autostartTitle": "Attempting to Start the BankID App",
      "autostartDescription": "If you do not have the BankID app installed on the same device you are using, then click on 'BankID on other device' below.",
      "bankIdOnThisDevice": "Use BankID on this device",
      "bankIdOnAnotherDevice": "Use BankID on another device",
      "bankIdTestFlow": "Test flow (with SSN)",
      "qrCodeInstructions": "How to use",
      "qrCodeStep1": "Start the Mobile BankID app",
      "qrCodeStep2": "Click on the QR icon in the app",
      "qrCodeStep3": "Point the camera at the QR code displayed here on the screen",
      "qrCodeStep4": "Identify yourself in the app",
      "abortLogin": "Cancel authentication",
      "ssn": "Personal number",
      "ssnHelper": "Enter your Swedish personal number",
      "ssnPlaceholder": "YYYYMMDD-XXXX",
      "giveValidSSN": "Please enter a valid personal number"
    },
    "FI": {
      "selectBank": "Select your bank",
      "authInProgress": "Authentication in progress",
      "authInProgressDescription": "Please complete the authentication in the popup window or new tab. Do not close this window.",
      "noBankIdInfo": "Don't have BankID?",
      "getBankIdLink": "Get BankID here"
    },

    "errors": {
      "genericError": "Authentication failed. Please try again.",
      "userCancelled": "You cancelled the authentication.",
      "unauthorized": "You do not have access to this service",
      "timeout": "Authentication timed out. Please try again.",
      "startFailed": "Failed to start authentication. Please try again.",
      "popupBlocked": "Popup was blocked by browser. Please allow popups and try again.",
      "networkError": "Network error. Please check your connection and try again."
    }
  }
}
